import { render, staticRenderFns } from "./HrPerfCharge.vue?vue&type=template&id=5aba3987&scoped=true&"
import script from "./HrPerfCharge.vue?vue&type=script&lang=js&"
export * from "./HrPerfCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba3987",
  null
  
)

export default component.exports